// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"782":"8ba86a3d","1405":"42982afe","5202":"a53eb256"}[chunkId] + ".chunk.css";
};